<template>
  <div :class="['container flex items-center px-8 py-4 cursor-pointer', { 'selected-container-style': isSelect }]">
    <div class="flex gap-[18px] items-center shrink-0">
      <div class="shrink-0 w-6 h-6 overflow-hidden flex items-center justify-center">
        <img :src="imgSrc" class="w-full h-full object-contain" />
      </div>
      <p :class="['label', isSelect ? 'label-selected' : 'label-default']">{{ content }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isSelect: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: "Option 1"
    }
  }
}
</script>

<style scoped>
.container {
  border: 1px solid #c4c4c4;
  border-radius: 3px;
  background: #FFF;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.selected-container-style {
  border: 1px solid #004879;
  background: #F9FBFD;
}

.label {
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  line-height: 20px;
  white-space: nowrap;
  letter-spacing: 0.458px;
}

.label-default {
  color: #333;
}

.label-selected {
  color: #374957;
}

</style>
